/**
 * WordPress dependencies
 */
import { forwardRef, useRef } from '@wordpress/element';
import { useMergeRefs } from '@wordpress/compose';

/**
 * Internal dependencies
 */
import { ControlWithError } from '../control-with-error';
import ToggleControl from '../../toggle-control';

// TODO: Should we customize the default `missingValue` message? It says to "check this box".
import { jsx as _jsx } from "react/jsx-runtime";
const UnforwardedValidatedToggleControl = ({
  required,
  customValidity,
  markWhenOptional,
  ...restProps
}, forwardedRef) => {
  const validityTargetRef = useRef(null);
  const mergedRefs = useMergeRefs([forwardedRef, validityTargetRef]);
  return /*#__PURE__*/_jsx(ControlWithError, {
    required: required,
    markWhenOptional: markWhenOptional,
    customValidity: customValidity,
    getValidityTarget: () => validityTargetRef.current,
    children: /*#__PURE__*/_jsx(ToggleControl, {
      ref: mergedRefs,
      required: required,
      ...restProps
    })
  });
};
export const ValidatedToggleControl = forwardRef(UnforwardedValidatedToggleControl);
ValidatedToggleControl.displayName = 'ValidatedToggleControl';